export const MAPPING_SUFFIX = '__mapping';
export const MAPPING_PATH_SUFFIX = '__path';

/**
 * Corresponds to InputMappingConstants.cs.
 * Wouldn't need to define this here if there was an easy way to generate it.
 */
export enum InputMappingConstants {
  MAPPING_BUILD = 'Build Data',
  // MAPPING_EXPOSE = "Expose Input",
  MAPPING_NULL = 'Null',
  MAPPING_IGNORE = 'Ignore',
  MAPPING_UNKNOWN = 'Unknown',
  MAPPING_RUN_CONVERTER_FLOW = 'Run Converter',
  CONVERTER_FLOW_CATEGORY_SEPARATOR = '|~|',
  MAPPING_SELECT = 'Select From Flow',
  MAPPING_CONSTANT = 'Constant',
  MAPPING_ARRAY = 'Build Array',
  MAPPING_ARRAY_CONCAT = 'Join Arrays',
  MAPPING_DATE = 'Constant Date',
  MAPPING_DATETIME = 'Constant Date and Time',
  MAPPING_MERGE_HTML = 'Merge HTML Text',
  MAPPING_MERGE_PLAIN = 'Merge Plain Text',
  MAPPING_DATETIME_CURRENT = 'Current Date Time',
  MAPPING_DATETIME_COMPUTE = 'Compute Date',
}

export enum OutputMappingConstants {
  MAPPING_ARRAY_FIRST_ITEM = 'Array - First Item',
  MAPPING_ARRAY_ITEMS = 'Array - Items',
  MAPPING_ARRAY_LAST_ITEM = 'Array - Last Item',
  MAPPING_CHANGE = 'Change Value',
  MAPPING_EXPOSE_PROPERTIES = 'Expose Properties', // why was this commented out before?
  // MAPPING_IGNORE = "Ignore",
  // MAPPING_PASS_THROUGH = "Pass Through",
  MAPPING_REFERENCE = 'Reference',
  MAPPING_RENAME = 'Rename',
  MAPPING_RUN_CONVERTER_FLOW = 'Run Converter Flow',
  MAPPING_CONVERTER_FLOW__MAPPING_INDEX = 2,
}

export const MappingSuffixes = [
  MAPPING_SUFFIX,
  '__rename',
  '__reference',
  MAPPING_PATH_SUFFIX,
  '__mergedPlain',
  '__properties',
  '__date',
  '__datetime',
  '__computeType',
  '__constant',
  '__runFlowId',
];
